const options = [
  {
    id: "1",
    label: "Toronto",
    slug: "Toronto",
  },
  {
    id: "2",
    label: "Mississauga",
    slug: "Mississauga",
  },
  {
    id: "3",
    label: "Oakville",
    slug: "Oakville",
  },
  {
    id: "4",
    label: "Milton",
    slug: "Milton",
  },
  {
    id: "5",
    label: "Burlington",
    slug: "Burlington",
  },
  {
    id: "6",
    label: "Brampton",
    slug: "Brampton",
  },
];

export default options;
